import { ProfileAddress } from '~/app/core/account/profile/models/profile-address';
import { ProfileEmployeeInfo } from '~/app/core/account/profile/models/profile-employee-info';
import { BaseEntity } from '~/app/core/models/base-entity.model';
import { Context } from '../../context/models/context';
import { Role } from '../../role/models/role';

export class User extends BaseEntity<User> {
  firstname?: string;
  lastname?: string;
  email?: string;
  phone?: string;
  username?: string;
  password?: string;
  roles: Role[] = [];
  contexts: Context[] = [];
  address?: ProfileAddress;
  employeeInfo?: ProfileEmployeeInfo;
  picture?: {
    id: string;
  };
  public get fullName() {
    return `${this.firstname ?? ''} ${this.lastname ?? ''}`.trim();
  }

  public get fullname() {
    return this.fullName;
  }
}
